import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
// import Swiper from 'swiper';
// import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';
import { horizontalLoop } from './components/gsapHorizontalLoop';
import { verticalLoop } from './components/gsapVerticalLoop';
import Draggable from 'gsap/Draggable';
import InertiaPlugin from 'gsap/InertiaPlugin';
import Lenis from 'lenis';
import Cookies from 'js-cookie';
import { lock, unlock } from 'tua-body-scroll-lock';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';

// Swiper.use([Autoplay, EffectFade, Pagination, Navigation]);

// Components

// Global
// window.Swiper = Swiper;
window.Alpine = Alpine;

// gsap
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable, InertiaPlugin);

// Clear ScrollTrigger scroll memory on page unload to prevent stale pin positions on reload
window.addEventListener('beforeunload', () => ScrollTrigger.clearScrollMemory());
window.gsap = gsap;
window.Draggable = Draggable;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.SplitText = SplitText;
window.InertiaPlugin = InertiaPlugin;
window.horizontalLoop = horizontalLoop;
window.verticalLoop = verticalLoop;
window.Lenis = Lenis;
window.Cookies = Cookies;
window.lock = lock;
window.unlock = unlock;

// Inits
Alpine.plugin(collapse);
Alpine.start();

// Initialize Lenis
// Recommended
const lenis = new Lenis({
  autoRaf: false,
  duration: 0.8,
  anchors: true,
  prevent: (node) => node.classList?.contains('js-modal')
});

lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);
